import { axios } from "../../helper/axios";
import { FeedbackConstant } from "./FeedbackConstant";

const FeedbackApi = {};

FeedbackApi.getFeedbackData = ({
  status,
  from_date,
  to_date,
  search_term,
  page = 1,
  limit
}) => {
  
  const queryParam = [];

  if (status) {
    queryParam.push(`status=${status}`);
  }
  if (page) {
    queryParam.push(`page=${page}`);
  }
  if (limit && limit!==0) {
    queryParam.push(`limit=${limit ?? 100}`);
  }
  if (search_term) {
    queryParam.push(`search=${search_term}`);
  }
  if (from_date && to_date) {
    queryParam.push(`startDate=${from_date}`, `endDate=${to_date}`);
  }

  // Join all parameters with '&'
  const queryString = queryParam.length ? `?${queryParam.join('&')}` : '';

  return axios.get(`${FeedbackConstant.FEEDBACK_API}${queryString}`);
};

FeedbackApi.getbulkExcelFeedbackData = ({ status, limit }) => {
  let qeuryParam;
  qeuryParam = `?status=${status}&limit=${(limit!==0 ? limit : 100) ?? 100}`;
  // if(search_term ){
  // qeuryParam=`?search_term=${search_term}`
  // }

  return axios.get(`${FeedbackConstant.FEEDBACK_API}${qeuryParam}`);
};

FeedbackApi.FeedBackReplybyId = ({ id, replyText }) => {
  return axios.put(`${FeedbackConstant.FEEDBACK_REPLY_API}/${id}`, {
    reply_to_feedback: replyText,
  });
};

export { FeedbackApi };
